var DeliveryMethod = /** @class */ (function () {
    function DeliveryMethod(obj, id) {
        if (id) {
            this.id = id;
        }
        this.bg_name = obj.bg_name;
        this.en_name = obj.en_name;
        if (obj.active) {
            this.active = obj.active;
        }
        this.price = obj.price;
        this.delivery_type = obj.delivery_type;
        if (obj.position) {
            this.position = obj.position;
        }
    }
    Object.defineProperty(DeliveryMethod.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeliveryMethod.prototype, "BgName", {
        get: function () {
            return this.bg_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeliveryMethod.prototype, "EnName", {
        get: function () {
            return this.en_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeliveryMethod.prototype, "Active", {
        get: function () {
            return this.active;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeliveryMethod.prototype, "Price", {
        get: function () {
            return this.price;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeliveryMethod.prototype, "DeliveryType", {
        get: function () {
            return this.delivery_type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeliveryMethod.prototype, "Position", {
        get: function () {
            return this.position;
        },
        enumerable: false,
        configurable: true
    });
    return DeliveryMethod;
}());
export { DeliveryMethod };
export function createDeliveryMethod(obj, id) {
    return new DeliveryMethod(obj, id);
}
export function createDeliveryMethods(rawMethods) {
    var methods = [];
    var rawMethodsData = rawMethods.data;
    for (var _i = 0, rawMethodsData_1 = rawMethodsData; _i < rawMethodsData_1.length; _i++) {
        var rawMethod = rawMethodsData_1[_i];
        var method = createDeliveryMethod(rawMethod.attributes, rawMethod.id);
        methods.push(method);
    }
    return methods;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/deliveryMethod/deliveryMethod.ts
// module id = 116
// module chunks = 0